import "./SelectRole.scss";
import  schoolIcon  from "../../../../../Assets/Registration/schools_icon.svg";
import  tutorIcon from "../../../../../Assets/Registration/tutors_icon.svg";
import  universityIcon from "../../../../../Assets/Registration/university_icon.svg";
import  activity_icon from "../../../../../Assets/Registration/activity-icon.svg";
import { Card, ListItemButton, ListItemText } from "@mui/material";
import { useEffect, useState } from "react";
import { NUMBER_CONSTANTS, STORAGE_KEYS } from "../../../../Utilities/Constants/Constants";
import { SetSessionStorageData, applyUserBasedTheme } from "../../../../Services/Helpers/Helper";
import { toast } from "react-toastify";
import { REGISTRATION_ERRORS } from "../../../../Utilities/Constants/Validations";

const SelectRole = (props:any)=>{
    const [ activeStep, setActiveStep ] = useState();
    /* useEffect(()=>{
          setActiveStep(props.activeStatus)NUMBER_CONSTANTS.FOUR
    },[]) */

    /* Update option state */
    const onselectOption = (value:any)=>{
        setActiveStep(value);
        SetSessionStorageData(STORAGE_KEYS.ROLE,value);
        applyUserBasedTheme();
    }

    /* Submit API call */
    const onSubmit = ()=>{
        if(activeStep){
            props.activeStatus(NUMBER_CONSTANTS.ONE);
        }else{
            toast.error(REGISTRATION_ERRORS.ROLE_SELECT);
        }
        
    }

    return(
      <div className="row select-role-wrapper">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className="list-card-wrapper">
                <Card className="card-wrapper">
                    <div className="card-head">
                        <h4>Your Role</h4>
                    </div>
                    <div className={activeStep===NUMBER_CONSTANTS.FOUR ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.FOUR)}> <img id="list-icons" src={tutorIcon}/>Tutor</div>                    
                    <div className={activeStep===NUMBER_CONSTANTS.NINE ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.NINE)}><img id="list-icons" src={activity_icon}/>Activities - Personal Trainer</div>
                    <div className={activeStep===NUMBER_CONSTANTS.FIVE ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.FIVE)}><img id="list-icons" src={activity_icon}/>Activities - Camp</div>
                    {/* <div className={activeStep===NUMBER_CONSTANTS.SIX ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.SIX)}><img id="list-icons" src={schoolIcon}/>School</div>
                    <div className={activeStep===NUMBER_CONSTANTS.SEVEN ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.SEVEN)}> <img id="list-icons" src={universityIcon}/> University</div>
                    <div className={activeStep===NUMBER_CONSTANTS.THREE ? "card-active" : "card-data"} onClick={()=>onselectOption(NUMBER_CONSTANTS.THREE)}> <img id="list-icons" src={universityIcon}/> Educational Expert</div> */}
                </Card>
               
            </div>
            <div className="button-wrapper">
                    <button className="btn submit-btn" onClick={onSubmit}>Next</button>
                </div>
        </div>
     </div>)
};

export default SelectRole;